import ufeApi from 'services/api/ufeApi';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+PayPal+Token

/**
 * Fetches PayPal token for checkout
 * @param {object} params - Request parameters
 * @param {string} [params.orderId] - Order ID for POST request
 * @param {string} [params.fulfillmentType] - Fulfillment type (SHIP, SAMEDAY, PICKUP) for POST request
 * @param {string} [params.shippingMethodId] - Shipping method ID for SDD express (e.g., 'SAME_DAY_UNSCHEDULED')
 * @param {boolean} [params.isExpressCheckout] - Flag to indicate express checkout flow (direct order placement)
 * @returns {Promise<object>} PayPal token response with { token, paypalSessionDetails }
 * @description
 * - If orderId AND fulfillmentType provided: sends POST request with payload
 * - Otherwise: sends GET request (backward compatible for old flow)
 */
async function getPayPalToken(params = {}) {
    const url = '/api/checkout/paypalToken';
    const { orderId, fulfillmentType, shippingMethodId, isExpressCheckout } = params;

    // TODO PAYPAL NEW FLOW: If BOTH parameters provided, send POST with payload
    if (orderId && fulfillmentType) {
        const payload = {
            orderId,
            fulfillmentType
        };

        // Include shipping method for SDD express checkout
        if (shippingMethodId) {
            payload.shippingMethodId = shippingMethodId;
        }

        // Flag for express checkout flow (direct order placement)
        if (isExpressCheckout) {
            payload.isExpressCheckout = isExpressCheckout;
        }

        const data = await ufeApi.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(payload)
        });

        if (data.errorCode) {
            throw data;
        }

        return data;
    }

    // TODO PAYPAL OLD FLOW: Missing orderId or fulfillmentType, use GET (backward compatible)
    const data = await ufeApi.makeRequest(url);

    if (data.errorCode) {
        throw data;
    }

    return data;
}

export default getPayPalToken;
